<div class="modal-header">
    <h3 class="modal-title text-modal-header-bold" id="modal-basic-title"> Materiales estándar</h3>
    <button (keydown.tab)="onNexFocus('nuevo')" type="button" class="close" aria-label="Close" (click)="cerrar()"  tabindex="205" >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form>
        <div class="row">
            <div class="col-md-12">

                <div class="input-group">
                    <label style="margin-right: 37px !important;" class="label-size tsiLabel mr-2">Tipo de
                        inventario</label>
                    <div class="col-sm-2">
                        <input (keydown.enter)="onKeyEnterTipoDocumento($event)" (blur)="onBlurTipoDocumento($event)"
                            type="text" class="focus-input input_border tsiInput form-control form-control-sm" [(ngModel)]="codTipoInventario"
                            name="codTipoInventario" #nomcont tabindex="1" style="text-align: center;">
                    </div>

                    <select id="cboTipoInventario" class="custom-select col-md-4 tsiSelect"
                        [(ngModel)]="codTipoInventario" name="codTipoInventario" tabindex="2"
                        (change)="onChangeTipoDocumento($event,codTipoInventario)">
                        <option *ngFor="let lst of tiposInventario" [value]="lst.tipinv">
                            {{lst.tipinv+' - '+lst.dtipinv}}
                        </option>
                    </select>

                </div>

                <div class="input-group">
                    <label style="margin-right: 103px !important;" class="label-size tsiLabel mr-2">Artículo</label>
                        <div class="col-sm-2">
                            <input [disabled]="disabledArticulo" type="text"
                                class="focus-input input_border tsiInput form-control form-control-sm"
                                id="codArticulo" name="codArticulo" [(ngModel)]="codArticulo"
                                [ngClass]="{'error': libre == true}" (keydown.enter)="onKeyEnterCodArticulo()"
                                (blur)="foc_interloc2()" type="text" tabindex="3" #interlocutor placeholder="-1"
                                style="text-align: center !important;">
                        </div>

                        <input [disabled]="disabledArticulo"
                            class="focus-input input_border form-control tsiInput col-md-6" id="desArticulo"
                            name="desArticulo" [(ngModel)]="desArticulo" [ngClass]="{'error': libre == true}"
                            tabindex="4" (keydown.enter)="onKeyEnterArticulo()" (blur)="foc_interloc()"
                            type="text" placeholder="Todos" style="margin-left: 10px !important;">

                        <div class="input-group-btn ">
                            <button *ngIf="buscarArticulo == 'buscar' "
                                class="btn btn-primary btn-sm boton m-b-5" (click)="openModalArticulo()"
                                type="button" tabindex="5" [disabled]="disabledAlmacen"><i
                                    class="fa fa-search"></i></button>
                            <button *ngIf="buscarArticulo == 'borrar'"
                                class="btn btn-primary btn-sm boton m-b-5" (click)="borrarArticulo()"
                                type="button" tabindex="5" [disabled]="disabledAlmacen"><i
                                    class="fas fa-times"></i></button>
                        </div>

                </div>


                <div class="input-group">
                    <label style="margin-right: 130px !important;" class="label-size tsiLabel mr-2">Clase</label>
                    <input  disabled type="text" class="form-control col-md-1 tsiInput mr-2" [(ngModel)]="codClase"
                        name="codClase" tabindex="3" style="text-align: center;">
                    <select disabled id="codClase" class="custom-select col-md-4 tsiSelect"
                        [(ngModel)]="codClase" name="codClase" tabindex="3">
                        <option *ngFor="let lst of clases" [value]="lst.clase">
                            {{lst.clase+' - '+lst.descri}}
                        </option>
                    </select>

                </div>

                <div class="row">
                    <div class="col-md-8" style="margin-top: 0px !important;">
                        <div class="row">
                        </div>
                    </div>

                    <div class="col-md-4" style="margin-top: 0px !important;">
                        <div class="row">
                            <div class="col-md-12" style="text-align: end; padding-right: 10px;">
                                <div class="input-group d-flex justify-content-end ">
                                    <button type="button" class="btn btn-rounded btn-info" tabindex="4"
                                        (click)="ConsultaMatEstandar()">
                                        <i class="fa fa-search"></i> Buscar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>


        </div>
    </form>
    <!--TABLA-->
    <div class="table-responsive" style="height: 650px;">
        <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
            <thead>
                <tr>
                    <th style="text-align: center;">Tip. Inv</th>
                    <th style="text-align: center;">Descripción de inventario</th>
                    <th style="text-align: left;">Cod. Art</th>
                    <th style="text-align: left;">Descripción de artículo</th>
                    <th style="text-align: right;">Etapa</th>
                    <th style="text-align: right;">Cantidad</th>
                    <th style="text-align: right;">Und</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let lst of materiales">
                    <td style="text-align: left;">{{lst.tipinvstd}}</td>
                    <td style="text-align: left;">{{lst.dtipinvstd}}</td>
                    <td style="text-align: left;">{{lst.codartstd}}</td>
                    <td style="text-align: left;">{{lst.desartstd}}</td>
                    <td style="text-align: left;">{{lst.etapa}}</td>
                    <td style="text-align: left; white-space: nowrap;">{{lst.cantid}}</td>
                    <td style="text-align: right;">{{ lst.coduni }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>